import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/min/index.js';

var require$$34 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$34 as default };
